import CommonRouter from './CommonRouter'
import { socialRoutes } from '../routes/SocialRoutes' 
const CurrentNavigator =  CommonRouter('Home', socialRoutes.Feed)
export default CurrentNavigator
